export enum EStatusDevolucaoVenda {
  EmDigitacao = 1,
  AguardandoEmissao = 2,
  Concluida = 3,
  Cancelada = 4,
}
